import React, { Component } from 'react';
import { TURNOVER_CLASSES, getTurnoverIndexFromLabel } from '../../../../config';
import Slider from '../../../filters/types/turnover-sek';
import { applyTurnoverFilter, turnoverLabelsFromIndex } from '../../helpers/filter-helpers';

class Turnover extends Component {
    
    constructor(props) {
        super(props);
        this.slider = null;
        this.state = {
            values: this.props.filters.turnovers.length > 0 ? getTurnoverIndexFromLabel(this.props.filters.turnovers) : [0, 19],
            turnoverClasses: TURNOVER_CLASSES,
            turnoverClass: []

        };
    }

    componentDidMount() {
        const result = this.props.units.reduce((total, value) => {
            if (value.turnoverClass !== '') {
                total[value.turnoverClass] = total[value.turnoverClass] ? { label: value.turnoverClass, count: total[value.turnoverClass].count + 1} : { count: 1, label: value.turnoverClass};
            }
            return total;
        }, {});

        const facetValues = Object.keys(result).map(key => {
            return {
                label: parseInt(result[key].label),
                count: result[key].count
            }
        });

        this.setState({
            turnoverClass: [{
                facetValues
            }],
        }, () => {
            this.props.registerFilter(this);
        });
    }

    filter(units) {
        const labels = turnoverLabelsFromIndex(this.state.values);
        const filteredUnits = applyTurnoverFilter(units, labels, this.props.type);
        return {
            filteredUnits, 
            filter:  {
                turnovers: labels
            }
        };
    }

    handleChange({ values }) {
        this.setState({
            values
        }, () => {
            this.props.previewFilter();
        });
    }

    registerSlider(comp) {
        this.slider = comp;
    }

    reset() {
        this.setState({
            values: [0, 19]
        }, () => {
            this.slider.handleChange(this.state.values);
            this.props.previewFilter();
        });
    }

    getPropertyName() {
        return this.props.propertyName;
    }

    getValues() {
        return turnoverLabelsFromIndex(this.state.values);
    }

    render() {

        if (!this.props.units) return null;

        return (
            <div className="map-filters__filter">
                {this.props.heading &&
                    <h2 className="map-filters__filter-heading">{this.props.heading}</h2>
                }
                <Slider caption={this.props.caption ? this.props.caption : <span className="classification-form__caption-light">(KKR/år)</span>} 
                        param="turnover" 
                        registerComponent={(comp) => this.registerSlider(comp)}
                        turnoverclass={this.state.turnoverClass} 
                        turnoverClasses={this.state.turnoverClasses} 
                        disableFreeText={true} 
                        modifiers={this.props.modifiers}
                        values={this.props.filters.turnovers.length > 0 ? getTurnoverIndexFromLabel(this.props.filters.turnovers) : this.state.values}
                        submitForm={(e, param, args) => this.handleChange(args)} />
            </div>
        );
    }
};

export default Turnover;